export default __webpack_public_path__ + "static/media/ecosystem-globe.c5cf2b76.png";